import { useCallback, MutableRefObject } from 'react';

type GuardKey = string | number;

/**
* Prevents duplicate async calls using a ref guard.
* Skips execution if already in-flight, otherwise runs and resets when complete.
 */
export function useGuardedAsync(inFlightKeyRef: MutableRefObject<GuardKey | null>) {
  return useCallback(
    <T>(key: GuardKey, actionFactory: () => Promise<T>, onFinally?: () => void) => {
      if (inFlightKeyRef.current === key) return;

      inFlightKeyRef.current = key;

      return actionFactory().finally(() => {
        // Only clear if this call is still the tracked one — a newer key may have started.
        if (inFlightKeyRef.current === key) inFlightKeyRef.current = null;
        onFinally?.();
      });
    },
    [inFlightKeyRef],
  );
}
